// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO
 */
export interface CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO
     */
    contentType: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTOContentTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTOContentTypeEnum {
    Png = 'image/png',
    Jpeg = 'image/jpeg'
}



